import { render, staticRenderFns } from "./AdsPopup.vue?vue&type=template&id=6f72c0d8&scoped=true"
import script from "./AdsPopup.vue?vue&type=script&lang=js"
export * from "./AdsPopup.vue?vue&type=script&lang=js"
import style0 from "./AdsPopup.vue?vue&type=style&index=0&id=6f72c0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72c0d8",
  null
  
)

export default component.exports